import {useLoanAppByNamespaceRole} from 'src/queries/loanApp';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { applicationUseMutation } from 'src/graphqlhooks';
import { GET_BORROWERS_BY_ACCOUNT_ID, GET_LOANAPP_BY_LOAN_ROLE_ACCOUNT } from 'src/services/grapqlQueries/loanAppQuery';

export const getLoanAppByNamespace = (accounId: any) => {
    const variables = {
        object_meta: {
            namespace: getNamespaceName(),
            account: accounId
        }
    }
    const { data, isLoading } = useLoanAppByNamespaceRole(variables);
    return { data, isLoading }
}

export const useAllLoansForByNamespace = () => {
    const [loanDataCheck] = applicationUseMutation(
        GET_LOANAPP_BY_LOAN_ROLE_ACCOUNT,
        {}
    );
    const onPullAllLoansByNamespace = (
        accountId: string,
    ) => {
        return loanDataCheck({
            variables: {
                object_meta: {
                    namespace: getNamespaceName(),
                    account: accountId
                }
            }
        });
    };
    return { onPullAllLoansByNamespace };
};

export const useLoansBorrowerForByNamespace = () => {
    const [loanDataCheck] = applicationUseMutation(
        GET_BORROWERS_BY_ACCOUNT_ID,
        {}
    );
    const onPullBorrowersByAccountId = (
        accountId: string,
    ) => {
        return loanDataCheck({
            variables: {
                object_meta: {
                    namespace: getNamespaceName(),
                    account: accountId
                }
            }
        });
    };
    return { onPullBorrowersByAccountId };
};
